export const externalLinks = {
    slack: 'https://slack.com/app_redirect?channel=CKNDKHCF7',
    mailTo: 'mailto:ae-coreapps@soluto.com',
    baseCamp: 'https://3.basecamp.com/3793693/projects/11845166',
    backoffice: 'https://sdk-backoffice.anywhere.expert/',
    webApiDocumentation: 'https://ae-sdk.io/docs/web-sdk/',
    nativeApiDocumentation: 'https://ae-sdk.io/docs/native-sdk/',
};
